var React = require('react');

function ArrowUpIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M21.47,11.89c0.34-0.3,0.53-0.7,0.53-1.12c0-0.42-0.19-0.82-0.53-1.12l-8.19-7.18\n                c-0.17-0.15-0.37-0.27-0.59-0.34C12.47,2.04,12.24,2,12,2c-0.24,0-0.47,0.04-0.69,0.12c-0.22,0.08-0.42,0.2-0.59,0.35L2.53,9.65\n                c-0.7,0.62-0.7,1.62,0,2.24c0.71,0.62,1.85,0.62,2.56,0l5.11-4.48v13.16C10.19,21.45,11,22,12,22s1.81-0.55,1.81-1.43V7.41\n                l5.11,4.48C19.62,12.51,20.77,12.5,21.47,11.89z"}));
}

ArrowUpIcon.defaultProps = {"data-dmid":"dm-arrow-up","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = ArrowUpIcon;

ArrowUpIcon.default = ArrowUpIcon;
